import axiosInstance from "./AxiosInstance";
import config from "../config";

export const fetchAllOffers = (page, size) => {

    const token = JSON.parse(sessionStorage.getItem('userDetails'))?.result?.token;

    return axiosInstance({
        url: config.routes.offers,
        method: 'get',
        headers: {
            "Authorization": `Bearer ${token}`
        },
        params: {
            page,
            size
        },
    });
};

export const fetchOfferDetails = (id) => {

    const token = JSON.parse(sessionStorage.getItem('userDetails'))?.result?.token;

    return axiosInstance({
        url: config.routes.offerDetails(id),
        method: 'get',
        headers: {
            "Authorization": `Bearer ${token}`
        }
    });
};

export const fetchOffersSent = (page, size) => {

    const token = JSON.parse(sessionStorage.getItem('userDetails'))?.result?.token;

    return axiosInstance({
        url: config.routes.offersSent,
        method: 'get',
        headers: {
            "Authorization": `Bearer ${token}`
        },
        params: {
            page,
            size
        },
    });
};

export const fetchOffersReceived = (page, size) => {

    const token = JSON.parse(sessionStorage.getItem('userDetails'))?.result?.token;

    return axiosInstance({
        url: config.routes.offersReceived,
        method: 'get',
        headers: {
            "Authorization": `Bearer ${token}`
        },
        params: {
            page,
            size
        },
    });
};

export const addOffer = (id, businessId, data) => {

    const token = JSON.parse(sessionStorage.getItem('userDetails'))?.result?.token;

    return axiosInstance({
        url: id !== null ? config.routes.offerDetails(id) : config.routes.createOffer,
        method: id !== null ? 'put' : 'post',
        headers: {
            "Authorization": `Bearer ${token}`
        },
        data: {
            "businessid": businessId,
            "currency": {
                id: parseInt(data?.currency)
            },
            "equity": parseInt(data?.equity),
            "message": data?.message,
            "price": parseInt(data?.price)
        }
    });
};

export const deleteOffer = (id) => {

    const token = JSON.parse(sessionStorage.getItem('userDetails'))?.result?.token;

    return axiosInstance({
        url: config.routes.offerDetails(id),
        method: 'delete',
        headers: {
            "Authorization": `Bearer ${token}`
        }
    });
};

export const acceptOffer = (id) => {

    const token = JSON.parse(sessionStorage.getItem('userDetails'))?.result?.token;

    return axiosInstance({
        url: config.routes.acceptOffer(id),
        method: 'put',
        headers: {
            "Authorization": `Bearer ${token}`
        }
    });
};

export const rejectOffer = (id) => {

    const token = JSON.parse(sessionStorage.getItem('userDetails'))?.result?.token;

    return axiosInstance({
        url: config.routes.rejectOffer(id),
        method: 'put',
        headers: {
            "Authorization": `Bearer ${token}`
        }
    });
};

export const offersPerBusiness = (id, page, size) => {

    const token = JSON.parse(sessionStorage.getItem('userDetails'))?.result?.token;

    return axiosInstance({
        url: config.routes.offersPerbusiness(id),
        method: 'get',
        headers: {
            "Authorization": `Bearer ${token}`
        },
        params: {
            page,
            size
        },
    });
};